export default "__VITE_ASSET__Q0tH39SB__"